import { c as _c } from "react/compiler-runtime";
import { IconShieldExclamation } from "@tabler/icons-react";
import { Alert, AlertDescription, AlertTitle } from "@domainstack/ui/alert";
import { cn } from "@domainstack/ui/utils";
import { describeTlsValidationError } from "@domainstack/utils/tls";
export function CertificateAlert(t0) {
  const $ = _c(25);
  let className;
  let error;
  let props;
  let title;
  let validationError;
  if ($[0] !== t0) {
    ({
      validationError,
      error,
      className,
      title,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = error;
    $[3] = props;
    $[4] = title;
    $[5] = validationError;
  } else {
    className = $[1];
    error = $[2];
    props = $[3];
    title = $[4];
    validationError = $[5];
  }
  let t1;
  if ($[6] !== validationError) {
    t1 = describeTlsValidationError(validationError);
    $[6] = validationError;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const copy = t1;
  const description = error || copy.description;
  const resolvedTitle = title ?? copy.title;
  let t2;
  if ($[8] !== className) {
    t2 = cn(className);
    $[8] = className;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconShieldExclamation aria-hidden={true} className="size-4" />;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== resolvedTitle) {
    t4 = <AlertTitle>{resolvedTitle}</AlertTitle>;
    $[11] = resolvedTitle;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== description) {
    t5 = <p>{description}</p>;
    $[13] = description;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== validationError) {
    t6 = validationError ? <p className="font-mono text-[11px] text-muted-foreground">{validationError}</p> : null;
    $[15] = validationError;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <AlertDescription>{t5}{t6}</AlertDescription>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== props || $[21] !== t2 || $[22] !== t4 || $[23] !== t7) {
    t8 = <Alert variant="destructive" className={t2} {...props}>{t3}{t4}{t7}</Alert>;
    $[20] = props;
    $[21] = t2;
    $[22] = t4;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}